(function (angular) {
    'use strict';

    /**
     * Service that provides common functionality around site settings
     *
     * @returns {void}
     */
    function siteSettingsManager() {
        /**
         * Determines whether a string is a colour hex like #ffcc00
         *
         * @returns {boolean}
         */
        function isColorHex(color) {
            return /^color_/.test(color);
        }

        /**
         * Transforms a colour hex into the format required by laravel's validation
         * (with # and uppercase)
         *
         * @param {string} hex
         * @returns {string}
         */
        function transformColorValue(hex) {
            return hex.replace(/^#?([a-fA-F0-9]{6})$/, '#$1').toUpperCase();
        }

        /**
         * Transforms any color (hex) values into the format required by laravel's validation
         * (with # and uppercase)
         *
         * @param {object} siteSettings
         * @returns {object} siteSettings with transformed color values
         */
        function transformColorValues(siteSettings) {
            angular.forEach(siteSettings, function (value, key) {
                if (/^color_/.test(key.toString())) {
                    siteSettings[key] = transformColorValue(value);
                }
            });

            return siteSettings;
        }

        return {
            isColorHex: isColorHex,
            transformColorValue: transformColorValue,
            transformColorValues: transformColorValues,
        };
    }
    siteSettingsManager.$inject = [

    ];

    angular.module('app')
        .service('siteSettingsManager', siteSettingsManager);

}(angular));
